
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Link from './link'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "component-name"
    }}>{`Component Name`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong></p>
    <hr />
    <h2 {...{
      "id": "component-name-1"
    }}>{`Component name`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <Playground __position={1} __code={''} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Link
    }} mdxType="Playground">
    </Playground>
    <hr />
    <h2 {...{
      "id": ""
    }}></h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <Playground __position={3} __code={''} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Link
    }} mdxType="Playground">
    </Playground>
    <hr />
    <h2 {...{
      "id": "-1"
    }}></h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <Playground __position={5} __code={''} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Link
    }} mdxType="Playground">
    </Playground>
    <hr />
    <h2 {...{
      "id": "-2"
    }}></h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <Playground __position={7} __code={''} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Link
    }} mdxType="Playground">
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Link} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;